<template>
  <div class="mod-config">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;" label="因子名称：">
        <el-input v-model="dataForm.name" placeholder="因子名称" clearable></el-input>
      </el-form-item>
      <el-form-item style="float: left;" label="因子编码：">
        <el-input v-model="dataForm.code" placeholder="因子编码" clearable></el-input>
      </el-form-item>
      <el-button @click="search()" type="primary" icon="el-icon-search" style="float: left;"></el-button>
      <el-form-item style="float: right;">
        <el-button icon="el-icon-back" @click="returnd()" style="font-size: 16px;"></el-button>
        <el-button type="primary" @click="addOrUpdateHandle()">新增</el-button>
        <el-button type="success" @click="channelExcel()">导出Excel</el-button>
        <el-button type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0">批量删除</el-button>
      </el-form-item>
    </el-form>
    <template>
      <!--      <el-button style="float: left;clear: both;background: #409eff;color: #fff;">{{ this.$route.query.row.name }}</el-button>-->
      <el-table :data="dataList" v-loading="dataListLoading" @selection-change="selectionChangeHandle"
        style="width: 100%;" height="calc(100% - 104px)" border stripe :header-cell-style="{background:'#FAFAFA'}"
        placement="top">
        <el-table-column type="selection" header-align="center" align="center" width="50">
        </el-table-column>
        <el-table-column prop="id" header-align="center" align="center" label="ID">
        </el-table-column>
        <el-table-column prop="code" header-align="center" align="center" label="因子编码">
        </el-table-column>
        <el-table-column prop="name" header-align="center" align="center" label="因子名称">
        </el-table-column>
        <el-table-column prop="unit" header-align="center" align="center" label="单位">
        </el-table-column>
        <el-table-column prop="firstAlarmValue" header-align="center" align="center" label="一级预警值">
        </el-table-column>
        <el-table-column prop="secondAlarmValue" header-align="center" align="center" label="二级预警值">
        </el-table-column>
        <el-table-column prop="note" header-align="center" align="center" label="描述信息">
        </el-table-column>
        <el-table-column v-if="('deviceChannel:formula')" prop="formula" header-align="center" align="center"
          label="修正公式">
        </el-table-column>
        <el-table-column v-if="isAuth('deviceChannel:formula')" prop="variable" header-align="center" align="center"
          label="参数 json格式">
        </el-table-column>
        <el-table-column prop="type" header-align="center" align="center" label="类型">
          <template slot-scope="scope">
            <label v-if="scope.row.type === 0">
              监测值
            </label>
            <label v-else>
              计算值
            </label>
          </template>
        </el-table-column>
        <el-table-column prop="sort" header-align="center" align="center" label="监测顺序">
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="修改" placement="top">
              <el-button v-if="isAuth('deviceChannel:add') || isAuth('deviceChannel:update')" type="text" size="small"
                @click="addOrUpdateHandle(scope.row.id)" style="font-size: 18px;"><i class="el-icon-edit-outline"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top">
              <el-button v-if="isAuth('deviceChannel:delete')" type="text" @click="deleteHandle(scope.row.id)"
                style="font-size: 18px;"><i class="el-icon-delete"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="修正公式" placement="top">
              <el-button type="text" v-if="isAuth('deviceChannel:formula')" @click="formulaHandled(scope.row)"
                style="vertical-align: middle;">
                <img src="../../assets/img/modbus4.png" alt="" style="margin-bottom: 7px;" width="18" height="18">
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" :content=" scope.row.isConceal === 1 ? '隐藏' : '显示'" placement="top">
              <el-button type="text" v-if="isAuth('deviceChannel:hide')" @click="disableHandled(scope.row)"
                style="font-size: 18px;vertical-align: middle;">
                <img v-if="scope.row.isConceal === 1" src="../../assets/img/modbus3.png" alt=""
                  style="margin-bottom: 7px;" width="20" height="20">
                <img v-if="scope.row.isConceal === 0" src="../../assets/img/modbus5.png" alt=""
                  style="margin-bottom: 7px;" width="20" height="20">
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
      :page-sizes="[5, 10, 15, 50]" :page-size="pageSize" :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    <el-dialog title="编辑修正公式" :visible.sync="formulaHandle" :modal-append-to-body="false" :show-close="false"
      :close-on-click-modal="false" width="30%" :before-close="handleClose">
      <div class="layui-fluid" id="device-update-formula">
        <form class="layui-form" action="" style="height: auto !important;">
          <div class="layui-form-item">
            <label class="layui-form-label">添加变量：</label>
            <div class="layui-input-block">
              <div class="layui-input-inline">
                <div class="layui-form-item">
                  <button @click="addCalc()" type="button" style="float: left;width: 100px;"
                    class="layui-btn  layui-btn-radius layui-btn-normal layui-btn-sm">
                    <i class="layui-icon">添加</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- 循环列出数据 -->
          <div id="last" style="overflow: hidden;overflow-y: scroll;height: 250px;margin-bottom: 20px;">
            <div class="layui-form-item" :model="dataFormNew">
              <label class="layui-form-label">A：</label>
              <div class="layui-input-inline">
                <select id="codeSelect" name="formulaSelect" model="A" style="display: block;" placeholder="请选择">
                  <option></option>
                  <option v-for="item in channelCodes" :key="item.name" :label="item.name" :value="item.code">
                  </option>
                </select>
              </div>
              <div class="layui-input-block" style="margin-left: 50%">
                <button type="button" style="float: left;width: 50px;border-radius: initial;"
                  class="layui-btn layui-btn-danger layui-btn-radius layui-btn-sm removeclass"><i
                    class="layui-icon">&#xe67e;</i></button>
              </div>
            </div>
          </div>

          <div class="layui-form-item">
            <label class="layui-form-label">修正公式：</label>
            <el-tooltip class="item" effect="dark" content="输入A-P代表通道1-通道15的因子作为变量，
            通过“添加”按钮添加变量；输入'+'、'-'、'*'、'/'代表进行四则运算；
            输入'log()'代表进行对数运算;
            输入'^'代表进行指数运算; 输入'sqrt()'代表进行开根运算；'()'内的优先计算" placement="top">
              <div class="layui-input-block">
                <input type="text" v-model="deviceFormula" autocomplete="off" placeholder="请输入修正公式" class="layui-input"
                  style="width: calc(100% - 60px);">
              </div>
            </el-tooltip>
          </div>
        </form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="formulaOut()">取 消</el-button>
        <el-button type="primary" @click="formula()">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style scoped>
#device-update {
  padding: 20px 25px 25px 0;
}

#device-update .layui-treeSelect .ztree li a, .ztree li span {
  margin: 0 0 2px 3px !important;
}

.layui-form-item select {
  /*display: block;*/
  width: 100%;
  height: 38px;
  border: 1px solid #d2d2d2;
}
</style>
<script>
import AddOrUpdate from './devicechannel-add-or-update'
import {excel, isAuth} from "@/utils";

var nex = 'B'.charCodeAt(0);
var num = 1;
export default {
  data() {
    return {
      dataForm: {
        name: '',
        code: ''
      },
      dataList: [],
      channelCodes: [],
      pageIndex: 1,
      pageSize: 15,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      formulaHandle: false,
      deviceFormula: "",
      dataFormNew: {},
      formulaChannelId: '',
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.getDataList();
  },
  methods: {
    search(){
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.pageIndex = 1
      this.$http({
        url: this.$http.adornUrl('/deviceChannel/list'),
        method: 'get',
        params: this.$http.adornParams({
          'page': this.pageIndex,
          'limit': this.pageSize,
          'deviceId': this.$route.query.id,
          'name': this.dataForm.name,
          'code': this.dataForm.code,
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.dataList = data.data.rows
          this.totalPage = data.data.total
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg)
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {
        });
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      if (!id) {//新增只需要设备id
        id = {deviceId: this.$route.query.id};
      }
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 删除
    deleteHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/deviceChannel/delete'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    returnd() {
      this.$router.replace({path: '/indexhome/device'});
    },
    //导出
    channelExcel() {
      excel("/deviceChannel/excel",this.$route.query.name+"因子信息-" + this.$moment(new Date()).format("yyyyMMDDHHmm"), {
        'pageNum': this.pageIndex,
        'pageSize': this.pageSize,
        'params': this.dataForm.params,
        'deviceId': this.$route.query.id,
      })
    },
    //修正公式
    formulaHandled(row) {
      this.channelCodes = [];
      this.formulaHandle = true;
      //获取下拉框值
      this.$http({
        url: this.$http.adornUrl('/deviceChannel/ChannelCodes/' + this.$route.query.id),
        method: 'get',
        params: this.$http.adornParams({
          'name': this.dataFormNew.name,
          'code': this.dataFormNew.code,
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.channelCodes = data.data;
        }
      })
      //设置通道因子id
      this.formulaChannelId = row.id
      //删除元素
      $("body").on('click', ".removeclass", function () {
        //元素移除前校验是否被引用
        let approvalName = $(this).parent().prev('div.layui-input-inline').children().val();
        let parentEle = $(this).parent().parent();
        parentEle.remove();
        num--;
        nex--;
      });
    },
    //退出修正公式并且刷新路由
    formulaOut(){
      this.formulaHandle = false;
      this.$router.go(0)
    },
    //权限
    isAuth(key) {
      return isAuth(key)
    },
    //计算公式添加
    addCalc() {
      if (num <= 15) {
        let str =
          '<div class="layui-form-item">' +
          '<label class="layui-form-label">' + String.fromCharCode(nex) + '：</label>' +
          '<div class="layui-input-inline">' +
          '<select style="display: block;width:100%;height: 38px;border:1px solid #d2d2d2;" name="formulaSelect" model="' + String.fromCharCode(nex) + '" id="codeSelect' + nex + '">' +
          '<option value=""></option>' +
          '</select></div>' +
          '<div class="layui-input-block" style="margin: 0;width: auto;min-height: initial;">' +
          '<button type="button" style="width: 50px;float: left" class="layui-btn layui-btn-danger layui-btn-sm removeclass"><i class="layui-icon">&#xe67e;</i></button>' +
          '</div>' +
          '</div>';
        $("#last").append(str);
        $.each(this.channelCodes, function (index, item) {
          $('#codeSelect' + nex).append(new Option(item.name, item.code));// 下拉菜单里添加元素
        });
        num++;
        nex++;
      } else {
        this.$message.error('最多添加15条');
      }
    },
    //  提交修正公式
    formula() {
      let formulaStr = this.deviceFormula
      let bool = false
      let obj = ''
      $("select[name='formulaSelect']").each(function (j, item) {
        //获取选中值
        let value = document.getElementsByTagName("select")[j].value
        if (formulaStr.length > 0 && (value === '' || value === '请选择')) {
          bool = true
          return
        }
        //获取变量值
        let name = document.getElementsByTagName("select")[j].attributes.model.value
        //处理拼接json字符
        let o = '"' + name + '":"' + value + '",'
        obj = obj + o
      });
      if (obj === '') {
        bool = true
      }
      //判断选择变量值
      if (bool) {
        this.$message({
          message: "请选择变量值",
          type: 'error',
        })
        return
      }
      //处理成json字符
      obj = "{" + obj.substr(0, obj.length - 1) + "}"
      this.$http({
        url: this.$http.adornUrl('/deviceChannel/formula/'),
        method: 'post',
        data: this.$http.adornData({
          "id": this.formulaChannelId,
          formula: this.deviceFormula,
          variable: obj,
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.formulaHandle = false
          this.getDataList()
          this.$message({
            message: data.msg,
            type: 'success',
          })
        } else {
          this.$message({
            message: data.msg,
            type: 'error',
          })
        }
      })
    },
    //显示-隐藏通道
    disableHandled(row) {
      this.$confirm(`是否【 ${row.isConceal === 1 ? '隐藏' : '显示'} 】通道 - ${row.name}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl(`/deviceChannel/isShow`),
          method: 'post',
          data: this.$http.adornData({
            'id': row.id,
            'isConceal': row.isConceal === 1 ? 0 : 1,
          })
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.$message({
              message: data.msg,
              type: 'success',
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/devicechannel.vue